import DatasetChip from 'components/CleanRooms/CurrentQuestions/DatasetChip';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import {
  StageLabel,
} from 'components/CleanRooms/CurrentQuestions/QuestionsTableLayout/TableCellComponents';


const QuestionDatasetRow = ({ question }) => (
  <>
    <Box display='flex' p={1}>
      <Box width='40%' mr={1}>
        <Tooltip placement='top-start' title='DATASET'>
          <Typography variant='subtitle4'>
            DATASET
          </Typography>
        </Tooltip>
      </Box>
      <Grid container spacing={2} alignItems='center'>
        <Grid item>
          <DatasetChip question={question} />
        </Grid>
        <Grid item>
          <StageLabel row={question} />
        </Grid>
      </Grid>
    </Box>
    <Divider />
  </>
);

export default QuestionDatasetRow;
